{
  "manager": {
    "index": {
      "connectionTokenTitle": "POS Connection Token",
      "instructions": "Generate a token to connect to the POS. Enter this token on the POS when prompted.",
      "yourTokenIs": "Your token is:",
      "expiresInLabel": "Expires in:",
      "tokenExpired": "The token has expired. Generate a new token to connect to the POS.",
      "generateToken": "Generate Token",
      "pageTitle": "Terminal",
      "expired": "Expired"
    }
  }
}
